export const muiStyles = () => ({
    flexColumn: {
        display: 'flex' as 'flex',
        flexFlow: 'column nowrap' as 'column nowrap',
        flexGrow: 1,
        justifyContent: 'center' as 'center',
        alignItems: 'center' as 'center'
    },
    blurbText: { paddingBottom: '30px' },
    blurbErrorText: {
        width: '70%',
        color: '#FA5252',
        textAlign: 'center' as 'center'
    },
    fullWidth: {
        width: '100%',
        alignSelf: 'center' as 'center'
    }
});